import styled from 'styled-components'

const InfoMatchStyled = styled.div`
    #info-match {
      font-size: 17px;
      line-height: 25px;
    }
`

export default InfoMatchStyled